module.exports = __webpack_public_path__ + "assets/img/18_922_big.df3c2220.jpg";